import { render } from "./BaseInput.vue?vue&type=template&id=1edde753"
const script = {}

import "./BaseInput.vue?vue&type=style&index=0&id=1edde753&lang=scss"
script.render = render

export default script